import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useJwtAuth } from './useJwtLogin';
import Loading from './Loading';

type RouteParams = {
  organizationId?: string;
};

type Props = {
  uuid: string;
};

const LoginWithUUID: React.FC<Props> = ({ uuid }) => {
  const { organizationId } = useParams<RouteParams>();
  const history = useHistory();
  const { t } = useTranslation();
  const { doLoginByUUID } = useJwtAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!organizationId || !uuid) {
      setIsLoading(false);
      setError(t('signIn.uuidError'));
      return;
    }

    doLoginByUUID(uuid, organizationId)
      .then((result) => {
        setIsLoading(false);
        if (result !== 'success') {
          setError(t('signIn.uuidError'));
        }
      })
      .catch(() => {
        setIsLoading(false);
        setError(t('signIn.uuidError'));
      });
  }, [doLoginByUUID, uuid, organizationId, t]);

  const handleBackToLogin = () => {
    history.push('/login');
  };

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return (
      <div>
        <h4 className="alert-heading">{t('signIn.uuidErrorTitle')}</h4>
        <p>{error}</p>
        <hr />
        <button
          className="btn btn-primary"
          onClick={handleBackToLogin}
          type="button">
          {t('signIn.backToLogin')}
        </button>
      </div>
    );
  }

  return <></>;
};

export default LoginWithUUID;
